import React from 'react'
import { LastSection } from '../components/Home/LastSection'
import { WelcomeSection } from '../components/Home/WelcomeSection'
import FooterOutside from '../components/Layout/FooterOutside'
import { Navbar } from '../components/Navbar/Navbar'
import { SEO } from '../components/seo'
import { openSpoke, registerRedirect } from '../utils/router'
import { MeetingBotAPIContent } from './lets-do-this'

const Home = () => {
    return (
        <main className="snap-mandatory">
            <SEO
                title="Gmeet Recorder | By Meeting Baas 🐟 "
                description="Transcribe and interact with any meeting using a meeting bot. "
                isHomePage={true}
            />
            <div className=" overflow-y-scroll h-screen min-h-screen min-w-screen max-w-screen overflow-x-hidden bg-neutral-50">
                <Navbar />
                <WelcomeSection
                    title1="Recording bot for"
                    title2=""
                    title3="Google Meet"
                    subtitle1="Use Spoke App to record Google Meet as a end-user."
                    subtitle2="Or create your platform through our API."
                    buttonName="Get Started through Meeting BaaS 🐟"
                    secondButtonName="Try our end-user app"
                    onButtonClick={registerRedirect}
                    onSecondButtonClick={openSpoke}
                />
                <MeetingBotAPIContent path={'transcription-api'}></MeetingBotAPIContent>
                {/* <HomeSpokeBot></HomeSpokeBot> */}
                {/* <FeaturesSection /> */}
                <LastSection />
                <div className="snap-start min-w-screen max-w-screen overflow-x-hidden bg-neutral-900">
                    <FooterOutside />
                </div>
            </div>
        </main>
    )
}
export default Home
